export default "__VITE_ASSET__BihJabi2__"